const CONFIGURATION = {
    defaultTheme: 'unbounded-light',
    authorizedDomains: ['unbounded.network'],
    apps: {
        mipasa: {
            enabled: false,
        },
        unbounded: {
            enabled: true,
            url: 'https://unbounded.network',
        },
        papillon: {
            enabled: false,
        },
        crypto: {
            enabled: false,
        },
        dpasa: {
            enabled: false,
        },
        soikie: {
            enabled: false,
        },
    },
    oidc: {
        github: false,
        google: true,
        ethereum: true,
    },
    sentry: {
        enabled: true,
        dsn: 'https://a7607287ba53453897b34276cb967443@o952724.ingest.sentry.io/6753216',
        tunnel: '/tunnel',
        environment: 'Unbounded',
    },
};
export default CONFIGURATION;
